import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomSyncAiMappingCostsToMapMutation } from "generated/graphql";

export const useSyncAiMappingCostsToMap = () => {
  const [mutation, { data, loading, error }] = useCustomSyncAiMappingCostsToMapMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "syncAiMappingCostsToMap" },
    { hideMessage: true }
  );
};
